import { Checkbox, DropDownList, TextBox } from "@repo/ui";

import type { LayerFilterProps } from "../hooks/useUpdateLayerFilter";

import { ClientSideLabel } from "./clientSideLabel";
import { DateRangeFilter } from "./dateRangeFilter";
import { EnrollmentIdFilter } from "./enrollmentIdFilter";
import { LayerMachinesDropdown, LayerRepsDropdown } from "./entityDropdowns";
import { SegmentDropdowns } from "./segmentDropdowns";

const GPS_ACCURACY_OPTIONS = [
	{ label: "Any", value: "" },
	{ label: "300 Meters (Recommended)", value: 300 },
	{ label: "500 Meters", value: 500 },
	{ label: "1000 Meters", value: 1000 },
	{ label: "2500 Meters", value: 2500 },
];

export function RepresentativesFilters({ layer, updateFilter }: LayerFilterProps) {
	const isReps = layer.itemType === "Representatives";

	return (
		<>
			<SegmentDropdowns layer={layer} updateFilter={updateFilter} clientSide={false} />
			{isReps ? (
				<>
					<LayerRepsDropdown layer={layer} updateFilter={updateFilter} />
					<Checkbox
						id="activeRepOnly"
						label="Active Reps Only"
						value={layer.activeRepOnly ?? false}
						changeHandler={updateFilter}
						inline
					/>
				</>
			) : (
				<>
					<LayerMachinesDropdown layer={layer} updateFilter={updateFilter} />
					<Checkbox
						id="activeMachineOnly"
						label="Active Machines Only"
						value={layer.activeMachineOnly ?? false}
						changeHandler={updateFilter}
						inline
					/>
				</>
			)}
			<EnrollmentIdFilter layer={layer} updateFilter={updateFilter} />
			<DropDownList
				id="minAccuracy"
				label="Minimum GPS Accuracy"
				placeholder="Any"
				value={layer.minAccuracy}
				// "Any" comes through as "", which the layer stores as no minimum.
				changeHandler={(value: number | "") => updateFilter(value || undefined, "minAccuracy")}
				values={GPS_ACCURACY_OPTIONS}
				fullLength
			/>
			<DateRangeFilter layer={layer} updateFilter={updateFilter} dateOnly />
			<Checkbox
				id="lastPositionOnly"
				label={<ClientSideLabel label="Last Position Only" />}
				value={layer.lastPositionOnly ?? false}
				changeHandler={updateFilter}
				inline
			/>
			{layer.lastPositionOnly ? (
				<TextBox
					id="hourLimit"
					label={<ClientSideLabel label="Last Updated Within Hours" />}
					type="number"
					inputMode="numeric"
					maxlength={4}
					value={layer.hourLimit ?? ""}
					changeHandler={updateFilter}
				/>
			) : (
				<Checkbox
					id="showLines"
					label={<ClientSideLabel label="Show Route Paths" />}
					value={layer.showLines ?? false}
					changeHandler={updateFilter}
					inline
				/>
			)}
		</>
	);
}
